module.exports = {"AE":{"code":"AE","name":"الإمارات العربية المتحدة","cities":["دبي","أبو ظبي","الشارقة"],"countryCode":"+971"}}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/data/countries_ar.json
// module id = 1704
// module chunks = 2